import React from "react";
import styles from "./index.module.scss";

const Author = ({ title, description, image, subtitle }) => {
  return (
    <div className={styles.banner}>
      <div className={styles.imageWrapper}>
        <img
          width="124"
          height="124"
          src={image}
          alt={title}
          className={styles.image}
        />
      </div>
      <div className={styles.content}>
        <div>
          <div className={styles.title}>{title}</div>
          <div className={styles.subtitle}>{subtitle}</div>
        </div>
        <div className={styles.description}>{description}</div>
      </div>
    </div>
  );
};

export default Author;
